import { useQuery } from '@apollo/react-hooks';
import { type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { SelectOption } from '../../../components';

type SRSListType = {
  countryList: SelectOption[];
  provinceList: SelectOption[];
  residenceTypeList: SelectOption[];
  disabilityTypeList: SelectOption[];
};
type GetSRSList = {
  programmeChoiceMetadata: SRSListType;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetSRSList = (): GetSRSList => {
  const { data, loading, error } = useQuery<GetSRSList>(
    gql`
      query {
        programmeChoiceMetadata {
          countryList {
            value
            label
          }
          provinceList {
            value
            label
          }
          residenceTypeList {
            value
            label
          }
          disabilityTypeList {
            value
            label
          }
        }
      }
    `,
    {
      fetchPolicy: 'network-only',
    },
  );
  const programmeChoiceMetadata = data?.programmeChoiceMetadata as SRSListType;

  return {
    programmeChoiceMetadata: programmeChoiceMetadata ?? {
      countryList: [],
      provinceList: [],
      residenceTypeList: [],
      disabilityTypeList: [],
    },
    loading,
    error,
  };
};
